export const parseSubjectsFromUrl = () =>
  window.location.pathname
    .replace(/(\/)\1+/g, '/')
    .split('/')
    .slice(2, 7)

export const removeYearFromSubjects = (subjects = []) => {
  if (subjects.length === 5 && subjects.includes('in')) {
    subjects.splice(2, 1)
    return subjects
  }
  if (subjects.length > 2 && !subjects.includes('in'))
    return subjects.slice(0, -1)

  return subjects
}

export const removeCountryFromSubjects = (subjects = []) =>
  subjects.slice(0, -2)
